import { 
    GET_PACKAGE,
    GET_PACKAGES,
    CREATE_PACKAGE,
    UPDATE_PACKAGE,
    DELETE_PACKAGE,
} from '../actions/types';

const initialState = {
    packages : [],
    package : {},
    assetPath: "",
    loading : false
}


export default (state = initialState, { type, payload }) => {    
    switch (type) {
        case GET_PACKAGE:
            return {
                ...state,
                package: payload.productPackage,
                assetPath: payload.assetPath,
                loading: false 
            };
            
        case GET_PACKAGES:
            return {
                ...state,
                packages: payload.productPackages,
                loading: false
            };

        case CREATE_PACKAGE:
            return {
                ...state,
                packages: [...state.packages, payload],
                package: payload,
                loading: false
            };

        case UPDATE_PACKAGE:
            return {
                ...state,
                packages: state.packages.map(pkg => 
                    pkg._id === payload._id ? payload : pkg
                ),
                package: payload,
                loading: false
            };

        case DELETE_PACKAGE:
            return {
                ...state,
                packages: state.packages.filter(pkg => pkg._id !== payload),
                loading: false
            };

        default:
            return state
    }
};